<template>
    <div class="gauge-container">
      <div class="header">
        <h1>漏损分析</h1>
      </div>
      
      <div class="chart-container">
        <div class="chart-wrapper">
          <div ref="chart" style="width: 100%; height: 100%;"></div>
        </div>
        <!-- <div>

          <div ref="chart" style="width: 100%; height: 100%;"></div>

        </div> -->
      </div>
      
      <!-- <div class="info-panel">
        <div class="info-item">
          <span class="label">当前进度:</span>
          <span class="value" :style="{color: colorSet.color}">{{ value }}%</span>
        </div>
        <div class="info-item">
          <span class="label">状态:</span>
          <span class="value" :style="{color: getStatusColor()}">{{ getStatusText() }}</span>
        </div>
      </div> -->
    </div>
  </template>
  
  <script>
  // 注意：在Vue项目中需要先安装echarts: npm install echarts
import * as echarts from 'echarts'

  
  export default {
    name: 'GaugeChart',
    props: {
      value: {
        type: Number,                                                                                                                                                               
        default: 44
      },
      title: {
        type: String,
        default: '完成进度'
      },
      color: {
        type: String,
        default: '#468EFD'
      }
    },
    data() {
      return {
        myChart: null,
        colorSet: {
          color: this.color
        },
        dataArr: this.value
      }
    },
    watch: {
      value(newVal) {
        this.dataArr = newVal
        this.updateChart()
      },
      color(newVal) {
        this.colorSet.color = newVal
        this.updateChart()
      },
      title() {
        this.updateChart()
      }
    },
    computed: {
      chartOption() {
        return {
          backgroundColor: 'transparent',
          tooltip: {
            formatter: "{a} <br/>{b} : {c}%"
          },
          series: [
            {
              name: "内部进度条",
              type: "gauge",
              radius: '55%',
              min: 0,
              max: 60,
              splitNumber: 6,
              axisLine: {
                lineStyle: {
                  color: [
                    [this.dataArr / 60, this.colorSet.color],
                    [1, "#111F42"]
                  ],
                  width: 12
                }
              },
              axisLabel: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              itemStyle: {
                show: false,
              },
              detail: {
                formatter: (value) => {
                  if (value !== 0) {
                    const num = Math.round(value)
                    return parseInt(num).toFixed(0) + "%"
                  } else {
                    return "0%"
                  }
                },
                offsetCenter: [0, 82],
                textStyle: {
                  padding: [0, 0, 0, 0],
                  fontSize: 24,
                  fontWeight: '700',
                  color: this.colorSet.color
                }
              },
              title: {
                show: true,
                offsetCenter: [0, 46],
                textStyle: {
                  color: "#fff",
                  fontSize: 18,
                  fontWeight: 400,
                  fontFamily: 'PingFangSC'
                }
              },
              data: [{
                name: this.title,
                value: this.dataArr,
              }],
              pointer: {
                show: true,
                length: '80%',
                radius: '25%',
                width: 14,
              },
              animationDuration: 1000,
            },
            {
              name: '外部刻度',
              type: 'gauge',
              radius: '65%',
              min: 0,
              max: 60,
              splitNumber: 6,
              startAngle: 225,
              endAngle: -45,
              axisLine: {
                show: true,
                lineStyle: {
                  width: 1,
                  color: [
                    [1, 'rgba(0,0,0,0)']
                  ]
                }
              },
              axisLabel: {
                show: true,
                color: '#4d5bd1',
                distance: 30,
                fontSize: 14,
                formatter: function(v) {
                  switch (v + '') {
                    case '0':
                      return '0'
                    case '10':
                      return '10'
                    case '20':
                      return '20'
                    case '30':
                      return '30'
                    case '40':
                      return '40'
                    case '50':
                      return '50'
                    case '60':
                      return '60'
                    default:
                      return ''
                  }
                }
              },
              axisTick: {
                show: true,
                splitNumber: 6,
                lineStyle: {
                  color: this.colorSet.color,
                  width: 2,
                },
                length: -10
              },
              splitLine: {
                show: true,
                length: -25,
                lineStyle: {
                  color: this.colorSet.color,
                  width: 2
                }
              },
              detail: {
                show: false
              },
              pointer: {
                show: false
              }
            }
          ]
        }
      }
    },
    mounted() {
      this.initChart()
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
      if (this.myChart) {
        this.myChart.dispose()
      }
    },
    methods: {
      initChart() {
        this.myChart = echarts.init(this.$refs.chart)
        this.myChart.setOption(this.chartOption)
        
        // 添加事件监听
        this.addEventListeners()
      },
      handleResize() {
        if (this.myChart) {
          this.myChart.resize()
        }
      },
      addEventListeners() {
        // 添加点击事件
        this.myChart.on('click', (params) => {
          this.$emit('value-change', params.value)
        })
      },
      updateChart() {
        if (this.myChart) {
          this.myChart.setOption(this.chartOption)
        }
      },
      getStatusText() {
        if (this.dataArr < 30) {
          return '较低'
        } else if (this.dataArr < 70) {
          return '中等'
        } else {
          return '较高'
        }
      },
      getStatusColor() {
        if (this.dataArr < 30) {
          return '#ff4d4f'
        } else if (this.dataArr < 70) {
          return '#faad14'
        } else {
          return '#52c41a'
        }
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .gauge-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .header {
    text-align: center;
    // margin-bottom: 40px;
    // padding: 20px;
    
    h1 {
      font-size: 32px;
      margin-bottom: 10px;
      background: linear-gradient(90deg, #468EFD, #4d5bd1);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
    
    p {
      color: #8ca0d7;
      font-size: 16px;
      max-width: 600px;
      margin: 0 auto;
      line-height: 1.6;
    }
  }
  .chart-container {
    height: 100%;
    display: flex;
    justify-content: center;
    // margin-bottom: 40px;
  }
  .chart-wrapper {
    width: 100%;
    max-width: 600px;
    height: 100%;
    // background: rgba(16, 23, 39, 0.5);
    border-radius: 12px;
    // box-shadow: 0 10px 30px rgba(0, 20, 80, 0.4);
    padding: 0px 20px;
    // border: 1px solid rgba(70, 142, 253, 0.2);
  }
  .info-panel {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-top: 20px;
    flex-wrap: wrap;
  }
  .info-item {
    background: rgba(20, 30, 50, 0.5);
    padding: 15px 20px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(70, 142, 253, 0.2);
    min-width: 150px;
    
    .label {
      font-size: 14px;
      color: #8ca0d7;
      margin-bottom: 5px;
    }
    
    .value {
      font-size: 18px;
      font-weight: bold;
    }
  }
  @media (max-width: 768px) {
    .chart-wrapper {
      height: 350px;
      padding: 15px;
    }
    
    .header h1 {
      font-size: 26px;
    }
    
    .info-panel {
      flex-direction: column;
      align-items: center;
    }
    
    .info-item {
      width: 100%;
      max-width: 300px;
    }
  }
  </style>